import { app } from '../../../../app';

app.component('requestCenterApprovalForms', {
    bindings: {
        approvalForms: '<',
        policies: '<',
        companyId: '<',
    },
    templateUrl: require('./approval-forms.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/approval-forms.component.js